import { MuiTheme } from "theme";
import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme: MuiTheme) => ({
  loader: {
    flex: "auto"
  },
  accordion: {
    "& .MuiCollapse-container": {
      padding: 8,
      margin: -8
    },
    paddingBottom: 10,
    flexDirection: "column"
  },
  accordionContent: {
    width: "100%"
  },
  tableWrapper: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    position: "relative",
    [theme.breakpoints.up("md")]: {
      flex: "auto"
    }
  },
  emptyDataHolder: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#c3c3c3",
    fontSize: 14
  },
  workout: {
    fontSize: 12,
    lineHeight: 1,
    color: theme.palette.text.secondary,
    borderBottom: "1px solid #eeeeee",
    "&:nth-child(even)": {
      backgroundColor: "#FBFBFB"
    }
  },
  vetShapeIcon: {
    fontSize: 10,
    marginRight: 10
  },
  workoutFlag: {
    border: "1px solid #CB0909",
    borderRadius: 3,
    backgroundColor: "#FF6363",
    padding: "2px 4px",
    color: theme.palette.common.white,
    marginLeft: 4,
    fontSize: 10,
    fontFamily: "SuisseIntlMedium"
  },
  workoutFlagIcon: {
    fontSize: 10,
    marginRight: 2
  },
  addCircleOutlineIcon: {
    fontSize: 16
  },
  workoutRowSelected: {
    position: "absolute",
    top: 36,
    backgroundColor: theme.palette.common.white,
    width: "100%",
    zIndex: 1
  },
  workoutFlaggedComment: {
    fontSize: 12,
    paddingBottom: 8
  },
  workoutFlaggedDate: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
    paddingTop: 0,
    paddingBottom: 0,
    border: "none",
    height: 30
  },
  workoutDetails: {
    minWidth: 108,
    padding: "4px",
    whiteSpace: "nowrap"
  },
  workoutReplay: {
    textAlign: "center"
  },
  workoutAnalysis: {
    textAlign: "center"
  },
  tableHeadDetails: {
    textAlign: "center",
    fontFamily: "SuisseIntlRegular",
    minWidth: 114
  },
  tableHeadReplay: {
    textAlign: "center",
    fontFamily: "SuisseIntlRegular"
  },
  tableHeadAnalysis: {
    textAlign: "center",
    fontFamily: "SuisseIntlMedium",
    paddingRight: 16,
    paddingLeft: 12
  },
  modal: {
    display: "flex",
    flexDirection: "column",
    zIndex: 1,
    position: "absolute",
    top: 72,
    width: "100%",
    backgroundColor: theme.palette.common.white,
    padding: 16
  },
  modalMessage: {
    height: 204
  },
  modalButtons: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 10
  },
  saveButton: {
    color: theme.palette.secondary.dark
  },
  textField: {
    height: "100%",
    borderColor: theme.palette.secondary.dark,
    color: theme.palette.secondary.dark,
    "& label.Mui-focused": {
      color: theme.palette.secondary.dark
    },
    "& .MuiOutlinedInput-root": {
      height: "100%",
      "& fieldset": {
        borderColor: theme.palette.secondary.dark
      },
      "&:hover fieldset": {
        borderColor: theme.palette.secondary.dark
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.secondary.dark
      }
    },
    "& .MuiFormHelperText-root": {
      position: "relative",
      paddingLeft: 8,
      bottom: 13,
      width: 60,
      backgroundColor: theme.palette.common.white,
      left: "82%",
      fontSize: 11
    },
    "& .MuiFormHelperText-contained": {
      marginLeft: 0
    },
    "& .MuiInputBase-input": {
      fontFamily: "SuisseIntlRegular",
      fontSize: 14
    }
  },
  textFieldError: {
    color: "#D81D18"
  },
  workoutList: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  workoutRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 3fr 1fr 1px",
    // Commented by reason temporary excluded workoutReplay and Analysis
    // gridTemplateColumns: "1fr 1fr 3fr 1fr 1fr",
    height: "36px",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 16px",
    color: theme.palette.text.primary,
    fontSize: 14,
    fontFamily: "SuisseIntlRegular"
  },
  workoutRowHeader: {
    borderBottom: "1px solid #eeeeee"
  },
  workoutDate: {
    fontFamily: "SuisseIntlMedium",
    minWidth: 60
  },
  workoutDateCell: {
    fontFamily: "SuisseIntlRegular",
    minWidth: 60
  },
  workoutTrack: {
    textAlign: "left",
    paddingLeft: 8
  },
  workoutDetailsData: {
    display: "flex",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 4px"
  },
  workoutAnalysisHead: {
    textAlign: "center",
    fontFamily: "SuisseIntlMedium"
  },
  flaggedComment: {
    display: "flex",
    flexDirection: "column",
    padding: "4px 16px 8px 16px"
  },
  commentVet: {
    color: theme.palette.text.primary,
    fontFamily: "SuisseIntlMedium",
    marginBottom: "8px"
  },
  commentDate: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
    marginBottom: "10px"
  },
  commentText: {
    fontSize: 12,
    color: theme.palette.text.primary,
    marginBottom: "8px"
  },
  dirtSurfaceIcon: {
    fontSize: 8,
    margin: "0 2px"
  },
  surfaceTurf: {
    border: `1px solid ${theme.palette.common.black}`,
    borderRadius: "50%",
    padding: 1,
    display: "inline-block",
    fontSize: 11,
    margin: "0 2px"
  },
  surfaceTurfInner: {
    border: `1px solid ${theme.palette.common.black}`,
    padding: 1,
    display: "inline-block",
    fontSize: 11,
    margin: "0 2px"
  },
  hidden: {
    display: "none"
  }
}));
